'use strict';

import globalConfig from '../settings/config';
const queryBuilder = function(
  collection,
  lat,
  lng,
  maxdist,
  loadMapWithMarkers,
  num_ranks = 0,
) {
  let fbQuery = globalConfig.endpoints.fb.url + '?';
  let params = [];
  if (collection) {
    params.push(`collection=${collection}`);
  }

  if (lat && lng) {
    params.push(`origin=${lat},${lng}`);
  }

  if (maxdist) {
    params.push(`maxdist=${maxdist}`);
  }

  if (num_ranks) {
    params.push(`num_ranks=${num_ranks}`);
  }

  if (loadMapWithMarkers) {
    params.push(`fake=${loadMapWithMarkers}`);
  }

  return fbQuery + params.join('&');
};

export default queryBuilder;
